<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        xAxis: {
          type: "category",
          data: ["Category 1", "Category 2", "Category 3"]
        },
        yAxis: { type: "value" },
        series: [
          {
            type: "boxplot",
            data: [
              [850, 740, 900, 1070, 1000],
              [960, 940, 990, 1140, 1100],
              [780, 760, 820, 880, 840]
            ]
          }
        ]
      }
    };
  }
};
</script>
